__turbopack_context__.v({
  "content": "styles-module-scss-module__LguqMW__content",
  "header": "styles-module-scss-module__LguqMW__header",
  "section": "styles-module-scss-module__LguqMW__section",
  "title": "styles-module-scss-module__LguqMW__title",
});
